import { default as FaqComponent } from '../../../../components/faq'
import { FaqEl } from '../elements/faq'
import faqData from '../config/faq'
import { H4 } from '../../../../styles/typography'

const Faq = () => {
  return (
    <FaqEl>
      <H4>
        Frequently
        <br />
        asked questions
      </H4>

      <FaqComponent data={faqData} />
    </FaqEl>
  )
}

export default Faq
